export default {
  setTotalItems: function (state, value) {
    state.totalItems = value
  },
  setTotalHold: function (state, value) {
    state.totalHold = value
  },
  setTotalApproved: function (state, value) {
    state.totalApproved = value
  }
}
